module.exports = __webpack_public_path__ + "media/images/profit-chart-icon-816cb532f5db4c21812d0153b264d232.png";